import { DetailedHTMLProps, ImgHTMLAttributes } from 'react';
import config from 'config/index';

interface IProps
  extends DetailedHTMLProps<
    ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  > {
  airlineCode: string;
}

export default function AirlineLogo({ airlineCode, ...props }: IProps) {
  return (
    // eslint-disable-next-line jsx-a11y/alt-text
    <img
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      src={`${config.cdnDomain}/flight/vertical-static/flight/airlines/${airlineCode}.png`}
      onError={e => {
        (e.target as HTMLImageElement).src =
          `${config.cdnDomain}/flight/vertical-static/flight/airlines/naver.png`;
      }}
    />
  );
}
